import { defineStore } from "pinia";

export const useloggedUserInfo = defineStore({
    id: "UserInfo",
    state: () => ({
        isAuth: false,
        user: null
    }),
    getters: {
        GetUserInfo: (state) => {
            alert(1);
            console.log("PiniaDataaaaaaa", state);
            if (state.user) {
                return {
                    address: state.address,
                    id: state.id,
                    CompanyId: state.companyId,
                    email: state.email,
                    employeeSettingName: state.employeeSettingName,
                    firstName: state.firstName,
                    

                }
            }
            return null;
        },
        getIsAuth: (state) => {
            return state.user ? true : false;
        }
    },
    actions: {
        async setUser(userProfile) {
            debugger;
           // this.user = { return userProfile };
            this.user= () => { return userProfile }
        },
        async SetUserInfo(key, value) {
            if (key == "menutype") {
                this.MenuType = value;
            }
            else if (key == "contextmenuclosed") {
                this.IsContextMenuClosed = value;
            }
            else if (key == "name") {
                //debugger;
                this.Name = 'Radhay Chauhan';
            }
        }
    },
    persist: true,
});

export const moduleStore = defineStore({
    id: "moduleMaster",
    state: () => ({
        ModuleId: 0,
    }),
    getters: {
        GetModuleId: (state) => state.ModuleId,
    },
    actions: {
        SetModuleId(value) {
            this.ModuleId = value;
        },
    },
});